module.exports = __webpack_public_path__ + "static/img/sign-in.60af50f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo/sign-in.png
// module id = b5fc
// module chunks = 0